export const EDITORIAL_UPDATED_AT = "2026-11-03";
export const LOCATION_DATA_VERIFIED_AT = "2026-11-03";
export const LOCATION_DATA_VERIFIED_LABEL = "3. November 2026";
